/** Contains styles for BasicTableXXX components */

import { Stack, styled, TableCell, TableHead } from "@mui/material";
import { styledOmitPropsOptions } from "../../../theme/styled.helpers";
import { SelectArrow } from "../../Icons";
import { HeadingXS } from "../../Typography";

export const MobileRowWrapper = styled(
    Stack,
    styledOmitPropsOptions,
)<{ $hasUnderline: boolean }>(({ theme, $hasUnderline }) => ({
    borderBottom: $hasUnderline ? "1px solid rgba(224, 224, 224, 1)" : "none",
    justifyContent: "space-between",
    padding: theme.spacing(3),
    gap: 16,

    "& > *": {
        width: "50%",
    },
}));

export const SelectArrowOrange = styled(SelectArrow)(({ theme }) =>
    theme.unstable_sx({
        transform: "rotate(270deg)",
        color: theme.palette.primary.main,
        mx: theme.spacing(3),
    }),
);

export const TableHeadStack = styled(Stack)(() => ({
    display: "inline-flex",
    alignItems: "center",
    "& > *": {
        display: "inline-flex",
        textWrap: "wrap",
    },
    paddingTop: "8px",
    paddingBottom: "8px",
}));

export const TableHeadStyled = styled(TableHead)(({ theme }) =>
    theme.unstable_sx({
        borderBottom: `2px solid ${theme.palette.primary.main}`,
        "& > *": {
            margin: 0,
        },
    }),
);

export const IconTableCell = styled(TableCell)(() => ({
    float: "left",
    paddingLeft: 0,
    paddingRight: 0,
}));

export const NewHeadingXS = styled(HeadingXS)(() => ({
    marginBottom: 0,
}));
